import { Col, InputNumber, Row, Slider } from 'antd';
import React from 'react';

const AddItemsContent = (props) => {
  return (
    <>
      <p style={{ fontSize: '9pt' }}>Platz</p>
      <Row>
        <Col span={12}>
          <Slider step={1} style={{minWidth: 120}} onChange={(cols) => props.setCols(cols)} min={1} max={50} value={props.cols} />
        </Col>
        <Col span={4}>
          <InputNumber min={1} max={50} style={{ marginLeft: '35px', maxWidth: 65}} value={props.cols} onChange={(cols) => props.setCols(cols)} />
        </Col>
      </Row>
      <p style={{ fontSize: '9pt' }}>Reihe</p>
      <Row>
        <Col span={12}>
          <Slider step={1} style={{minWidth: 120}} onChange={(rows) => props.setRows(rows)} min={1} max={50} value={props.rows} />
        </Col>
        <Col span={4}>
          <InputNumber min={1} max={50} style={{ marginLeft: '35px', maxWidth: 65}} value={props.rows} onChange={(rows) => props.setRows(rows)} />
        </Col>
      </Row>
    </>
  );
}

export default AddItemsContent;
